import { italianProvinces } from "../cvt/data/zoneMap";

export const durations = [12, 24, 36, 48, 60];
export const fieldSpacing = 2.5;
export const provinceNameToCodeMap = Object.fromEntries(
  italianProvinces.map((province) => [province.name, province.code]),
);

export const provinceOptions = italianProvinces
  .map((province) => province.name)
  .sort((a, b) =>
  a.localeCompare(b, "it"),
);

export const initialFormData = {
  targa: "",
  marca: "",
  modello: "",
  provincia: "",
  valoreVeicolo: "",
  durata: 24,
  nome: "",
  cognome: "",
};

export const packageDefinitions = [
  {
    id: "base",
    ratePackageKey: "Base",
    title: "Base",
    subtitle: "Protezione essenziale per il tuo veicolo",
    gradient: "linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%)",
    chipColor: "#2563eb",
    multiplier: 1,
    coverages: [
      "Valore a nuovo",
      "Incendio",
      "Furto totale e parziale",
      "Ricorso terzi da incendio",
      "Rottura cristalli",
      "Pacchetto accessori",
    ],
  },
  {
    id: "medio",
    ratePackageKey: "Medium",
    title: "Medio",
    subtitle: "Protezione estesa con garanzie aggiuntive",
    gradient: "linear-gradient(135deg, #f97316 0%, #ea580c 100%)",
    chipColor: "#ea580c",
    multiplier: 1.16,
    coverages: [
      "Valore a nuovo",
      "Incendio",
      "Furto totale e parziale",
      "Ricorso terzi da incendio",
      "Rottura cristalli",
      "Pacchetto accessori",
      "Eventi naturali",
      "Atti vandalici",
    ],
  },
  {
    id: "collisione",
    ratePackageKey: "Collisione",
    title: "Collisione",
    subtitle: "Include danni da collisione con altri veicoli",
    gradient: "linear-gradient(135deg, #22c55e 0%, #16a34a 100%)",
    chipColor: "#16a34a",
    multiplier: 1.8,
    coverages: [
      "Valore a nuovo",
      "Incendio",
      "Furto totale e parziale",
      "Ricorso terzi da incendio",
      "Rottura cristalli",
      "Pacchetto accessori",
      "Eventi naturali",
      "Atti vandalici",
      "Collisione animali selvatici",
      "Collisione",
    ],
  },
  {
    id: "kasko",
    ratePackageKey: "Kasko",
    title: "Kasko",
    subtitle: "Massima protezione - Danni propri inclusi",
    gradient: "linear-gradient(135deg, #a855f7 0%, #7e22ce 100%)",
    chipColor: "#7e22ce",
    multiplier: 2.15,
    coverages: [
      "Valore a nuovo",
      "Incendio",
      "Furto totale e parziale",
      "Ricorso terzi da incendio",
      "Rottura cristalli",
      "Pacchetto accessori",
      "Eventi naturali",
      "Atti vandalici",
      "Collisione animali selvatici",
      "Kasko",
    ],
  },
];

export const scopertiRows = [
  { label: "Furto / Incendio Totale", scoperto: "0%", franchigia: "€0", limite: "—", tone: "error" },
  { label: "Furto Parziale", scoperto: "10%", franchigia: "€250", limite: "—", tone: "error" },
  { label: "Eventi Naturali / Vandalismo", scoperto: "10%", franchigia: "€250", limite: "€6.000 per sinistro", tone: "warning" },
  { label: "Animali Selvatici", scoperto: "10%", franchigia: "€250", limite: "€3.000 anno", tone: "warning" },
  { label: "Collisione", scoperto: "10%", franchigia: "€600", limite: "—", tone: "primary" },
];
